import wixWindow from 'wix-window';
const RTLLangs = ['he','ar','fa'];
$w.onReady(function () {
    let lang = wixWindow.multilingual.currentLanguage;
    //based on RTL
    /////////////////////////////////////
    if(RTLLangs.includes(lang)){
        $w('#statebox8').changeState('RTL');
        }
    //based on exact match or default:
    /////////////////////////////////////
    let states = $w('#statebox8').states;
    let foundStates = states.filter((state)=>{state.id === lang});
    if(foundStates.length>0){
        $w('#statebox8').changeState(foundStates[0]);
    }
    else{
        $w('#statebox8').changeState('default');
    }
    //based on RTL
    /////////////////////////////////////
    if(RTLLangs.includes(lang)){
        $w('#statebox9').changeState('RTL1');
        }
    //based on exact match or default:
    /////////////////////////////////////
    if(foundStates.length>0){
        $w('#statebox9').changeState(foundStates[0]);
    }
    else{
        $w('#statebox9').changeState('default1');
    }
	    //based on RTL
    /////////////////////////////////////
    if(RTLLangs.includes(lang)){
        $w('#statebox10').changeState('RTL2');
        }
    //based on exact match or default:
    /////////////////////////////////////
    if(foundStates.length>0){
        $w('#statebox10').changeState(foundStates[0]);
    }
    else{
        $w('#statebox10').changeState('default2');
    }    //based on RTL
    /////////////////////////////////////
    if(RTLLangs.includes(lang)){
        $w('#statebox11').changeState('RTL3');
        }
    //based on exact match or default:
    /////////////////////////////////////
    if(foundStates.length>0){
        $w('#statebox11').changeState(foundStates[0]);
    }
    else{
        $w('#statebox11').changeState('default3');
    }
});